<div *ngIf="data">
  <app-details-header
    [type]="getResidentHRWithCase('M')"
    [header]="this.data.resident | fullName"
    icon="person"
    (onEdit)="onEdit()"
    [useEdit]="canEdit"
  >
    <p>
      {{ 'user.lastUpdate' | loc }}:
      <b>{{ data.resident.lastUpdate | lDate: 'dtShort' : ('label.never' | loc) }}</b>
    </p>
  </app-details-header>

  <div class="page-section">
    <app-details-section [noHeader]="true">
      <app-details-contacts
        [personalData]="data.resident"
        [canInvite]="canAuth"
        [canMessage]="canMessage"
        [canAlert]="canAlert"
      ></app-details-contacts>
    </app-details-section>
    <app-details-section headerKey="user.noteList">
      <app-notes [refId]="data.id" [type]="NoteType.LANDLORD" [disableEdit]="!canEdit"></app-notes>
    </app-details-section>
    <app-details-section
      [headerKey]="{ key: 'agr.detailsType', replaceMap: { $type: getResidentHRWithCase('D') } }"
      *ngIf="anyBasicDataExist"
    >
      <app-users-resident-basic-data
        [data]="data.resident"
        [type]="data.type"
        (showOwnerCodes)="showOwnerCodes = true"
      ></app-users-resident-basic-data>
    </app-details-section>

    <app-details-section headerKey="user.emergeContact" *ngIf="data.resident.emergencyContact">
      <app-users-resident-emergency-contact [contact]="data.resident.emergencyContact"></app-users-resident-emergency-contact>
    </app-details-section>

    <app-all-integration-codes [codes]="data.resident.residentCodes" [(show)]="showOwnerCodes"></app-all-integration-codes>

    <app-details-section
      *ngIf="data.apartments.length"
      [headerKey]="'PRSapartment.' + (data.apartments.length > 1 ? 'plural' : 'nominative')"
    >
      <app-users-rental-units-links [units]="data.apartments" [type]="RentalUnitType.APARTMENT"></app-users-rental-units-links>
    </app-details-section>

    <app-details-section
      *ngIf="data.parkingSpots.length"
      [headerKey]="'parking.' + (data.parkingSpots.length > 1 ? 'plural' : 'nominative')"
    >
      <app-users-rental-units-links [units]="data.parkingSpots" [type]="RentalUnitType.PARKING"></app-users-rental-units-links>
    </app-details-section>

    <app-details-section
      *ngIf="data.storages.length"
      [headerKey]="'storage.' + (data.storages.length > 1 ? 'plural' : 'nominative')"
    >
      <app-users-rental-units-links [units]="data.storages" [type]="RentalUnitType.STORAGE"></app-users-rental-units-links>
    </app-details-section>

    <app-details-section headerKey="user.mobile" *ngIf="user">
      <app-users-mobile-user-indicator
        [userData]="user"
        [personalData]="data.resident"
        [type]="data.type"
        [canRemove]="canAuth"
      ></app-users-mobile-user-indicator>
    </app-details-section>

    <app-details-section headerKey="agr.active" *ngIf="data.currentAgreements?.length">
      <app-users-prs-agreements-links [agreements]="data.currentAgreements"></app-users-prs-agreements-links>
    </app-details-section>

    <app-details-section *ngIf="data.futureAgreements?.length" headerKey="agr.future">
      <app-users-prs-agreements-links [agreements]="data.futureAgreements"></app-users-prs-agreements-links>
    </app-details-section>

    <app-details-section headerKey="agr.archivals" *ngIf="data.archivedAgreements?.length">
      <app-users-prs-agreements-links [agreements]="data.archivedAgreements"></app-users-prs-agreements-links>
    </app-details-section>
    <mat-expansion-panel *ngIf="data.type == ResidentType.LANDLORD" class="fliko-panel mat-elevation-z0" [expanded]="false">
      <mat-expansion-panel-header>
        <mat-panel-title>{{ 'label.attachments' | locUpper }}</mat-panel-title>
      </mat-expansion-panel-header>
      <app-details-section *ngFor="let agreement of data.currentAgreements" [last]="true">
        <ng-container section-header>
          <span class="mat-caption">
            {{ 'label.for' | loc }} {{ 'label.agrGenitive' | loc }} <b>{{ agreement.agreementNumber }}</b>
          </span>
        </ng-container>
        <app-users-details-files
          [agreementId]="agreement.id"
          [residentId]="data.id"
          (onGotoRefClicked)="dialogRef.close()"
          [canEdit]="canEdit"
        ></app-users-details-files>
      </app-details-section>
    </mat-expansion-panel>
  </div>
</div>
